import { Heading } from '@assembly-js/design-system';
import { IconButton } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

import { DesktopIcon } from 'src/components/icons';
import { MobileNotchIcon } from 'src/components/icons/MobileNotchIcon';

interface Props {
  previewMode: PreviewMode;
  onChangePreviewMode: (mode: PreviewMode) => void;
}

export enum PreviewMode {
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export const BillingPreviewHeader: React.FC<Props> = ({
  previewMode,
  onChangePreviewMode,
}) => {
  return (
    <div className="pb-6 flex justify-between items-center w-full">
      <Heading className="text-xl text-black-heading">Preview</Heading>
      <div className="flex gap-2 p-1 border border-solid border-non-hover-border rounded">
        <IconButton
          onClick={() => onChangePreviewMode(PreviewMode.Desktop)}
          className={clsx(
            'p-0 w-[38px] h-[26px] flex justify-center items-center',
            {
              'bg-secondary-hover hover:bg-secondary-hover rounded-[2px]':
                previewMode === PreviewMode.Desktop,
              'bg-transparent': previewMode !== PreviewMode.Desktop,
            },
          )}
        >
          <DesktopIcon
            className={clsx('w-[14px] h-[14px]', {
              'text-black-heading': previewMode === PreviewMode.Desktop,
              'text-gray-small': previewMode !== PreviewMode.Desktop,
            })}
          />
        </IconButton>
        <IconButton
          onClick={() => onChangePreviewMode(PreviewMode.Mobile)}
          className={clsx(
            'p-0 w-[38px] h-[26px] flex justify-center items-center',
            {
              'bg-secondary-hover hover:bg-secondary-hover rounded-[2px]':
                previewMode === PreviewMode.Mobile,
              'bg-transparent': previewMode !== PreviewMode.Mobile,
            },
          )}
        >
          <MobileNotchIcon
            className={clsx('w-[10px] h-[14px]', {
              'text-black-heading': previewMode === PreviewMode.Mobile,
              'text-gray-small': previewMode !== PreviewMode.Mobile,
            })}
          />
        </IconButton>
      </div>
    </div>
  );
};
